import history from "constants/history";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserAttributes } from "slices/authSlice";
import {
  PT_FILE,
  PT_USE_CAMERA,
  PT_SNAPPED_PICTURE,
  PT_EXISTING,
  PT_NONE,
  selectPreviewType,
  selectSettingPicture,
  confirmPicture,
  getConfirmPicAction,
  doConfirmPicAction,
  resetConfirmPicAction,
} from "slices/createPictureSlice";

interface ButtonState {
  onClick?: () => void;
  className: string;
  disabled: boolean;
  innerText: string;
}

function confirmButtonSuccessClick() {
  if (getConfirmPicAction()) doConfirmPicAction();
  else history.push("/");
}

const ConfirmButton = () => {
  const dispatch = useDispatch();
  const previewType = useSelector(selectPreviewType);
  const settingPicture = useSelector(selectSettingPicture);
  const [buttonState, setButtonState] = useState<ButtonState>({
    className: "forgotten-password text-muted bg-white mt-5",
    disabled: true,
    innerText: "",
  });
  const currentUserAttributes = useSelector(selectCurrentUserAttributes);

  useEffect(() => {
    return resetConfirmPicAction;
  }, []);

  useEffect(() => {
    switch (previewType) {
      case PT_FILE:
      case PT_SNAPPED_PICTURE:
        setButtonState({
          onClick: () => {
            confirmPicture().then(confirmButtonSuccessClick);
          },
          className: "confirm-button mt-4 growth-button mt-1",
          disabled: settingPicture,
          innerText: settingPicture ? "Loading..." : "Upload and Confirm",
        });
        break;
      case PT_USE_CAMERA:
        setButtonState({
          className: "forgotten-password text-muted bg-white mt-5",
          disabled: true,
          innerText: "Click Snap to Take a Picture",
        });
        break;
      case PT_EXISTING:
        setButtonState({
          onClick: confirmButtonSuccessClick,
          className: "confirm-button mt-4 growth-button mt-1",
          disabled: false,
          innerText: "Keep Existing Picture",
        });
        break;
      case PT_NONE:
        //If person had a picture before then confirmPicture and send a delete request to backend
        if (currentUserAttributes.avatar_key) {
          setButtonState({
            onClick: () => {
              confirmPicture().then(confirmButtonSuccessClick);
            },
            className: "forgotten-password text-muted bg-white mt-5",
            disabled: false,
            innerText: "Continue without a Picture",
          });
        } else {
          setButtonState({
            onClick: confirmButtonSuccessClick,
            className: "forgotten-password text-muted bg-white mt-5",
            disabled: false,
            innerText: "Continue without a Picture",
          });
        }
        break;
      default:
        setButtonState({
          className: "forgotten-password text-muted bg-white mt-5",
          disabled: true,
          innerText: "",
        });

        break;
    }
  }, [previewType, settingPicture, currentUserAttributes, dispatch]);

  return (
    <button
      onClick={buttonState.onClick}
      className={buttonState.className}
      disabled={buttonState.disabled}
    >
      {buttonState.innerText}
    </button>
  );
};

export default ConfirmButton;
